import { render, staticRenderFns } from "./VenueProduct.vue?vue&type=template&id=48525833&scoped=true&"
import script from "./VenueProduct.vue?vue&type=script&lang=js&"
export * from "./VenueProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48525833",
  null
  
)

export default component.exports